export default __webpack_public_path__ + "static/media/SAS0340.34I-41880_-25100_0.76148af0.jpg";